module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "owl-carousel"
  }, _vm._l((_vm.arr), function(items, i) {
    return _c('div', {
      staticClass: "item"
    }, [_c('p', {
      staticClass: "status"
    }, [_vm._v(_vm._s(i + 1) + " из " + _vm._s(_vm.arr.length))]), _vm._v(" "), _c('ul', {
      staticClass: "grid s_1 m_2 l_4"
    }, _vm._l((items), function(item) {
      return _c('li', [_c('div', {
        staticClass: "block"
      }, [(item.text) ? _c('a', {
        staticClass: "textItem",
        attrs: {
          "href": item.href
        }
      }, [_vm._v(_vm._s(item.text))]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "imgContainer"
      }, [(item.img) ? _c('a', {
        staticClass: "imgContent  waves-effect waves-light",
        style: (("background-image: url(" + (item.img) + ")")),
        attrs: {
          "href": item.href
        }
      }) : _vm._e()])])])
    }))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-43318158"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/sliderCategory.vue
// module id = 317
// module chunks = 22